import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-513d927e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "open-close-item"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "开停机时间", -1);
});
var _hoisted_4 = {
  class: "text"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "text"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "时段产量/吨", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_9 = {
  class: "info"
};
var _hoisted_10 = {
  class: "text"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "运行时长/时", -1);
});
var _hoisted_12 = {
  key: 0,
  class: "line"
};
var _hoisted_13 = {
  key: 1,
  class: "w-100 flex align-center"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "flex-1 flex justify-center"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "line1"
  })], -1);
});
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "flex-1 flex justify-center"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "line1"
  })], -1);
});
var _hoisted_16 = [_hoisted_14, _hoisted_15];
var _hoisted_17 = {
  class: "info text-ellipsis"
};
var _hoisted_18 = {
  class: "text"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "平均时产/吨", -1);
});
var _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"w-100 flex align-center\" data-v-513d927e><div class=\"flex-1 flex justify-center\" data-v-513d927e><div class=\"line1\" data-v-513d927e></div></div><div class=\"flex-1 flex justify-center\" data-v-513d927e><div class=\"line1\" data-v-513d927e></div></div><div class=\"flex-1 flex justify-center\" data-v-513d927e><div class=\"line1\" data-v-513d927e></div></div></div>", 1);
var _hoisted_21 = {
  class: "info text-ellipsis"
};
var _hoisted_22 = {
  class: "text"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "耗电量/度", -1);
});
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_25 = {
  class: "info text-ellipsis"
};
var _hoisted_26 = {
  class: "text"
};
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "吨耗电/度", -1);
});
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_29 = {
  class: "text"
};
var _hoisted_30 = {
  class: "label"
};
var _hoisted_31 = {
  key: 0,
  class: "blue"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.openCloseTime)), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["content", {
      width1: _ctx.type === '0',
      width2: _ctx.type === '1'
    }])
  }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.proNum)), 1), _hoisted_7]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.totalHour)), 1), _hoisted_11]), _ctx.type === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.proNumOneHour)), 1), _hoisted_19]), _ctx.type === '0' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.totalEle)), 1), _hoisted_23]), _hoisted_24, _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.tonEle)), 1), _hoisted_27])], 64)) : _createCommentVNode("", true), _hoisted_28, _createElementVNode("div", {
    class: "info text-ellipsis flex align-center",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.btnClick && _ctx.btnClick.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.closeNum)), 1), _createElementVNode("div", _hoisted_30, [_createTextVNode(" 停机次数 "), _ctx.item.closeNum !== '0' ? (_openBlock(), _createElementBlock("span", _hoisted_31, ">")) : _createCommentVNode("", true)])])], 2)]);
}